import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=16b89e6f&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=16b89e6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b89e6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b89e6f')) {
      api.createRecord('16b89e6f', component.options)
    } else {
      api.reload('16b89e6f', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=16b89e6f&scoped=true&", function () {
      api.rerender('16b89e6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Uq3IIPcO1KYq/JS/comp/GuestBox.vue"
export default component.exports